import React from 'react'

function Nothing() {
  return (
    <div className='w-full h-screen bg-[#1c1c8b]'>
          <h1 className='text-blue-600'>
              Hellooooooooooo
      </h1>
    </div>
  )
}

export default Nothing
